import triggerTracking from '@blueprint/tracking';

const EVENT = 'GAEvent';
const CATEGORY = 'homepage';

export const trackBrowseAllCitiesTownsUK = () => {
    triggerTracking({
        event: EVENT,
        eventCategory: CATEGORY,
        eventAction: 'clickthrough',
        eventLabel: 'browse_all'
    });
};

export const trackSeeAllUKForSale = () => {
    triggerTracking({
        event: EVENT,
        eventCategory: CATEGORY,
        eventAction: 'clickthrough',
        eventLabel: 'browse_all_properties_for_sale'
    });
};

export const trackSeeAllUKToRent = () => {
    triggerTracking({
        event: EVENT,
        eventCategory: CATEGORY,
        eventAction: 'clickthrough',
        eventLabel: 'browse_all_properties_to_rent'
    });
};

export const trackIndividualLocationForSale = (location: string) => {
    triggerTracking({
        event: EVENT,
        eventCategory: CATEGORY,
        eventAction: 'clickthrough',
        eventLabel: `browse_for_sale_${location.toLowerCase()}`
    });
};

export const trackIndividualLocationToRent = (location: string) => {
    triggerTracking({
        event: EVENT,
        eventCategory: CATEGORY,
        eventAction: 'clickthrough',
        eventLabel: `browse_to_rent_${location.toLowerCase()}`
    });
};
